<template>
    
    <BTable v-if="!is_reduction" :tbody-tr-class="rowClass" :items="items"  :fields="fields" show-empty >
        <template  v-slot:cell(company)="data">
            <BTooltip>
                <template #target>
                    <a target="_blank"  :href="'/kontrahenty/' + data.item.author_id">
                        {{data.item.company}}
                    </a>
                </template>
                Переглянути контрагента
            </BTooltip>
            
            <div v-if="data.item.comments" class="small">
                К-ть коментарів: {{data.item.comments}}
            </div>
        </template>
        
        <template  v-slot:cell(creater_name)="data">
            <BTooltip>
                <template #target>
                    <a target="_blank"  :href="'/kontrahenty/' + data.item.author_id">
                        {{data.item.creater_name}}
                    </a>
                </template>
                Переглянути контрагента
            </BTooltip>
        </template>
        
        <template  v-slot:cell(id)="data">
            <BTooltip>
                <template #target>
                    <a target="_blank" :href="'/zaiavky-na-uchast/' + data.item.id">
                        {{data.item.id}}
                    </a>
                </template>
                Переглянути заявку
            </BTooltip>
        </template>
    </BTable>
    
    <tender_nomenclature v-if="is_reduction" :as_app="true" :tender="tender"></tender_nomenclature>
    
    
</template>

<script>
import {
    BTooltip,
    BOverlay,
    BTable,
} from 'bootstrap-vue-next';

import tender_nomenclature from "./tender_nomenclature.vue";

export default {
    name: "tender_request",
    props : {
        tender: {
            type: Object,
            required: true
        }
    },
    components : {
        tender_nomenclature,
        BTable,
        BOverlay,
        BTooltip
    },
    
    data() {
        return {
            items : [],
            is_load : false,
            fields : [
                { key: 'id', label: 'ID' },
                {key : 'creater_name',label: 'Створив'},
                {key : 'company',label: 'Контрагент'},
                {key : 'date_create',label: 'Створена'},
                {key : 'h_status',label: 'Статус'},
            ],
        }
    },
    
    created() {
        if(!this.is_reduction) {
            this.loadRequest();
        }
    },
    
    methods : {
        
        rowClass(item) {
            if (!item) return;
            return 'app_' + item.status;
        },
        
        async loadRequest() {
            this.is_load = true;
            this.items = [];
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/applications").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    },
    
    computed : {
        is_reduction() {
            return this.tender.tender_type === 'second_reduction';
        }
    }
}
</script>

<style scoped>

</style>